export const cloneConfigModal = {
  close: "Fermer",
  searchPlaceholder: "Rechercher une annonce…",
  clearSearch: "Effacer",
  bar: {
    chooseSource: "Choisissez l'annonce source",
    selected: "{count} sélectionnée | {count} sélectionnées",
    selectAll: "Tout sélectionner",
    clear: "Effacer",
  },
  list: {
    loading: "Chargement des annonces…",
    empty: "Aucune annonce ne correspond à votre recherche.",
    unitsBadge: "{count} unités",
  },
  confirm: {
    sourceLabel: "Source choisie",
    applyToLabel: "S'appliquera à",
    andItsUnits: "(et ses {count} unités)",
    andMore: "et {count} de plus",
    undoWarning: "Cette action est irréversible.",
  },
  footer: {
    back: "Retour",
    cancel: "Annuler",
    continue: "Continuer",
  },
  preview: {
    unit: "Unité",
    listing: "Annonce",
    empty: "Non configuré.",
    loading: "Chargement…",
  },
  confirmTitle: {
    pull: "Confirmez avant d'importer",
    push: "Vérifiez avant de copier",
  },
  confirmLabel: {
    pulling: "Importation…",
    copying: "Copie…",
    confirmPull: "Oui, importer les réglages",
    confirmPush: "Oui, copier vers {count} annonce | Oui, copier vers {count} annonces",
  },
  intro: {
    pullLead: "Vous êtes sur le point d'importer {noun} depuis l'annonce que vous avez choisie.",
    pullReplace: "Cela remplacera ce que vous avez ici actuellement.",
    pullAdd: "Cela s'ajoutera à ce que vous avez déjà ici.",
    pushLead: "Vous êtes sur le point de copier {noun} vers {count} annonce. | Vous êtes sur le point de copier {noun} vers {count} annonces.",
    pushReplace: "Cela remplacera ce qu'elle a actuellement{scope}. | Cela remplacera ce qu'elles ont actuellement{scope}.",
    pushAdd: "Cela s'ajoutera à ce qu'elle a déjà. | Cela s'ajoutera à ce qu'elles ont déjà.",
    pushScope: ", y compris les réglages d'envoi",
  },
  attachments: {
    fileFallback: "Pièce jointe",
    titleAlsoCopied: "Les pièces jointes sont copiées elles aussi",
    titlePullLose: "Vous perdrez les pièces jointes que vous avez actuellement",
    titlePullGain: "Ses pièces jointes seront importées elles aussi",
    titlePushEmpty: "Les annonces choisies se retrouveront sans aucune pièce jointe",
    noteUnknownPull: "Les pièces jointes de l'annonce que vous avez choisie remplaceront celles d'ici, qui seront supprimées.",
    noteUnknownPush: "Les pièces jointes de cette annonce remplaceront celles des annonces choisies, qui seront supprimées.",
    notePullReplace: "Elles seront supprimées et remplacées par celles de l'annonce que vous avez choisie.",
    notePullEmpty: "Il n'y a aucune pièce jointe ici pour le moment, vous ne perdez donc rien : celles de l'annonce choisie seront importées.",
    notePushEmpty: "Cette annonce n'a aucune pièce jointe : celles de l'annonce choisie seront donc supprimées et elle se retrouvera sans aucune. | Cette annonce n'a aucune pièce jointe : celles des annonces choisies seront donc supprimées et elles se retrouveront sans aucune.",
    notePushReplace: "Elles seront copiées vers l'annonce choisie et remplaceront les siennes, qui seront supprimées. | Elles seront copiées vers les annonces choisies et remplaceront les leurs, qui seront supprimées.",
  },
  toast: {
    loadError: "Impossible de charger les annonces",
    pullSuccess: "Réglages importés avec succès",
    pushSuccess: "Réglages copiés vers {count} annonce | Réglages copiés vers {count} annonces",
    pullError: "Impossible d'importer les réglages",
    pushError: "Impossible de copier les réglages",
  },
};
